import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { useAssetLookup } from "../api/useAssetLookup";
import { AssetIcon } from "../components/AssetIcon";
import { formatGameTime } from "../format/formatGameTime";
import { formatList } from "../format/formatList";
import { FindingCard } from "./FindingCard";
import type { FindingProps } from "./FindingProps";
import { iconSize } from "./iconSize";

const TITLE = msg({
  id: "finding.enemy_escaped",
  message: "{hero} escaped from you with low HP {count, plural, one {once} other {# times}}",
});

const DETAILS = msg({
  id: "finding.enemy_escaped.details",
  message: "When: {times}.",
});

const ESCAPE_ITEMS = msg({
  id: "finding.enemy_escaped.escape_items",
  message: "Escape items they had:",
});

// Вражеский герой с низким HP был рядом и ушёл живым.
export const EnemyEscaped = ({ finding, variant }: FindingProps<"enemy_escaped">) => {
  const { i18n } = useLingui();
  const hero = useAssetLookup("heroes")(finding.params.hero_id);
  const findItem = useAssetLookup("items");
  const { count, times_s, escape_item_ids } = finding.params;
  const items = escape_item_ids.map(findItem);
  // Короткое пояснение — то же «когда», оно и так в одну строку.
  const details = i18n._({
    ...DETAILS,
    values: { times: formatList(times_s.map(formatGameTime), i18n.locale) },
  });
  return (
    <FindingCard
      code={finding.code}
      severity={finding.severity}
      variant={variant}
      icon={<AssetIcon asset={hero} size={iconSize(variant)} />}
      title={i18n._({ ...TITLE, values: { hero: hero.name, count } })}
      details={details}
      summary={details}
    >
      {items.length > 0 && (
        <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-subtle">
          <span>{i18n._(ESCAPE_ITEMS)}</span>
          <ul className="flex flex-wrap gap-2">
            {items.map((item) => (
              <li key={item.id} className="flex items-center gap-1" title={item.name}>
                <AssetIcon asset={item} size={24} className="rounded-md" />
                <span className="text-muted">{item.name}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </FindingCard>
  );
};
